export enum UrlVarsKey {
  AgentSaleNumberID = 'agentsalenumberid',
  SiteUserID = 'siteuserid',
  AffiliateId = 'affiliateid',
  BasicQuoteID = 'basicquoteid',
  QuoteID = 'quoteid',
  Source = 'source',
  AssociationId = 'associationid',
  TripDetails = 'tripdetails'
}

export type UrlVars = Record<UrlVarsKey | string, string>;
